import getGraphQlClient from '~graphql/getGraphQlClient';
import { FETCH_QUOTES } from '../queries/quotes';
import { unmarshalGraphqlResponse } from '~graphql/utils';

export const fetchQuotes = async (where) => {
  const graphQlClient = await getGraphQlClient();

  const result = await graphQlClient.query({
    fetchPolicy: 'network-only',
    variables: {
      where,
    },
    query: FETCH_QUOTES,
  });

  const epigrafi = await unmarshalGraphqlResponse(result.data, 'epigrafis')
    .edges;

  return epigrafi;
};
